import axios from 'axios';
import { Environment } from '../environment';

const Api = axios.create({
    baseURL: Environment.API_URL,
    headers: {
        'x-api-key': Environment.API_KEY,
    },
});

export default Api;
